import { useEffect } from 'react';
import { RefreshCw, Bot } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useStreamingAI } from '@/hooks/useStreamingAI';

export function MorningBrief() {
  const { content, isStreaming, error, stream, reset } = useStreamingAI();

  useEffect(() => {
    stream('morning-brief', {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRefresh = () => {
    reset();
    stream('morning-brief', {});
  };

  return (
    <Card className="h-full">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <Bot className="h-4 w-4" />
          AI Morning Brief
        </CardTitle>
        <Button variant="ghost" size="icon" onClick={handleRefresh} disabled={isStreaming}>
          <RefreshCw className={`h-4 w-4 ${isStreaming ? 'animate-spin' : ''}`} />
        </Button>
      </CardHeader>
      <CardContent className="max-h-80 overflow-auto">
        {isStreaming && !content && (
          <div className="space-y-2">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
            <Skeleton className="h-4 w-5/6" />
          </div>
        )}
        {error && !content && (
          <p className="text-sm text-muted-foreground">
            AI briefing unavailable. Check your tasks below.
          </p>
        )}
        {content && (
          <div className="prose prose-sm dark:prose-invert max-w-none whitespace-pre-wrap text-sm">
            {content}
            {isStreaming && <span className="inline-block h-4 w-1 animate-pulse bg-primary" />}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
